// extracted by mini-css-extract-plugin
export default {"primarybtn":"primarybutton_primarybtn__-7HDn"};